import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateCrypto } from "../../../state/cryptoSlice";
import { setSnackbarSuccess, setSnackbarError } from "../../../state/uiSlice";
import {
  Modal,
  Typography,
  Box,
  Grid,
  TextField,
  Button,
} from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};

export default function EditCryptoDialog({ open, handleClose, row }) {
  const dispatch = useDispatch();

  let [ticker, setTicker] = useState("");
  let [name, setName] = useState("");
  let [url, setUrl] = useState("");
  let [shares, setShares] = useState(0);
  let [totalSpent, setTotalSpent] = useState(0);

  const handleTickerChange = (event) =>
    setTicker(event.target.value);
  const handleNameChange = (event) => setName(event.target.value);
  const handleUrlChange = (event) => setUrl(event.target.value);
  const handleSharesChange = (event) => setShares(event.target.value);
  const handleTotalSpentChange = (event) => setTotalSpent(event.target.value);

  const handleModalClose = (event) => {
    handleClose();
  };

  const handleSubmit = () => {
    dispatch(updateCrypto({ ticker, name, url, shares, totalSpent, id: row.id }))
      .unwrap()
      .then(() => dispatch(setSnackbarSuccess(true)))
      .catch(() => dispatch(setSnackbarError(true)));
    handleModalClose();
  };

  useEffect(() => {
    setTicker(row.ticker)
    setName(row.name)
    setUrl(row.url)
    setShares(row.shares)
    setTotalSpent(row.totalSpent)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row]);

  return (
    <>
      <Modal
        open={open}
        onClose={handleModalClose}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSubmit();
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography component={"span"} id="modal-modal-title" variant="h6">
            Edit Crypto
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                id="outlined-basic"
                label="Ticker"
                variant="outlined"
                onChange={handleTickerChange}
                value={ticker}
                placeholder="Enter Ticker Symbol"
                helperText=""
                autoFocus
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="outlined-basic"
                label="Name"
                variant="outlined"
                onChange={handleNameChange}
                value={name}
                placeholder="Enter the cryptocurrency name"
                helperText="Bitcoin, etherieum, etc."
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="outlined-basic"
                label="URL"
                variant="outlined"
                onChange={handleUrlChange}
                value={url}
                placeholder="Enter the cointmarketcap url page for this cryptocurrency"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="outlined-basic"
                label="Shares"
                variant="outlined"
                onChange={handleSharesChange}
                value={shares}
                placeholder="Enter the total shares for this cryptocurrency"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id="outlined-basic"
                label="Total Spent"
                variant="outlined"
                onChange={handleTotalSpentChange}
                value={totalSpent}
                placeholder="Enter the total spent for this cryptocurrency"
              />
            </Grid>
            <Grid item xs={4}/>


            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                onClick={handleSubmit}
                sx={{ backgroundColor: "#0f4c75" }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
}
